import script from "./ToastBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./ToastBanner.vue?vue&type=script&setup=true&lang=js"

import "./ToastBanner.vue?vue&type=style&index=0&id=a5b483e6&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5b483e6"]])

export default __exports__